// frontend/src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify"; // <-- 1. IMPORTE O CONTAINER
import "react-toastify/dist/ReactToastify.css"; // <-- 2. IMPORTE O CSS

// Seus imports de página
import LoginPage from "./pages/LoginPage";
import Collection from "./pages/Collection";
import DashboardLayout from "./pages/DashboardLayout";
import CollectionListPage from "./pages/CollectionListPage";
import CreateQrCodePage from "./pages/CreateQrCodePage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Suas rotas continuam aqui... */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/collection/:collectionId" element={<Collection />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<CollectionListPage />} />
            <Route path="create" element={<CreateQrCodePage />} />
          </Route>
        </Route>
      </Routes>

      {/* 3. ADICIONE O TOAST CONTAINER AQUI */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
}

export default App;
